import authService from "./AuthService";
// import KryptoStreamer from '../services/KryptoStreamer';

class MessageFactory {
  // send = (opt, p, eid) => {
  //     const user = authService.getToken();
  //     if (user === null || user === undefined) return null;

  //     if (eid === undefined) eid = 100;

  //     const result = {
  //         v: '1.0.1',
  //         T: Date.now(),
  //         t: user.jti,
  //         eid,
  //         opt,
  //         p,
  //     };

  //     const json = JSON.stringify(result);
  //     KryptoStreamer.send(json);

  //     return result;
  // };

  // convertActionType = (action) => {
  //     if (action === 'setToken') return 100;

  //     return 0;
  // };

  createRequest = (actionType, token) => {
    const result = {
      v: "1.0.1",
      T: Date.now(),
      t: token,
      a: actionType,
      p: token,
    };

    return result;
  };

  serialize = (msg) => {
    return JSON.stringify(msg);
  };
}

const messageFactory = new MessageFactory();
export default messageFactory;
